import { defineStyleConfig } from "@chakra-ui/react";

const Button = defineStyleConfig({
  baseStyle: {
    fontFamily: "body",
    fontWeight: "500",
    borderRadius: "8px",
    _disabled: {
      opacity: 1,
      border: "1px solid",
      borderColor: "neutrals.stroke.sub-300",
      bg: "neutrals.background.weak-50",
      color: "neutrals.text.disabled-300",
    },
  },
  variants: {
    solid: (props) => {
      if (props.colorScheme === "brand") {
        return {
          bg: "primary.light.base",
          color: "primary.light.onstate",
          _hover: {
            bg: "primary.light.dark",
            _disabled: {
              bg: "neutrals.background.weak-50",
              color: "neutrals.text.disabled-300",
            },
          },
          _active: { bg: "primary.light.darker" },
        };
      }
      return {
        bg: "neutrals.background.strong-950",
        color: "neutrals.text.white-0",
        _hover: { bg: "neutrals.background.surface-800" },
        _active: { bg: "neutrals.background.intense-700" },
      };
    },
    outline: (props) => {
      if (props.colorScheme === "brand") {
        return {
          color: "primary.light.base",
          bg: "neutrals.surface.surface-0",
          borderColor: "primary.light.base",
          _hover: { bg: "primary.light.alpha-10" },
          _active: { bg: "primary.light.alpha-16" },
        };
      }
      return {
        color: "neutrals.text.sub-600",
        bg: "neutrals.surface.surface-0",
        borderColor: "neutrals.stroke.soft-200",
        _hover: { bg: "neutrals.background.weak-50" },
        _active: { bg: "neutrals.background.soft-200" },
      };
    },
    ghost: (props) => {
      if (props.colorScheme === "brand") {
        return {
          color: "primary.light.base",
          _hover: { bg: "primary.light.alpha-10" },
          _active: { bg: "primary.light.alpha-16" },
        };
      }
      return {
        color: "neutrals.text.sub-600",
        _hover: { bg: "neutrals.background.weak-50" },
        _active: { bg: "neutrals.background.soft-200" },
      };
    },
    subtle: (props) => {
      if (props.colorScheme === "brand") {
        return {
          color: "primary.light.base",
          bg: "primary.light.alpha-10",
          _hover: { bg: "primary.light.alpha-16" },
          _active: { bg: "primary.light.alpha-24" },
        };
      }
      return {
        color: "neutrals.text.sub-600",
        bg: "neutrals.background.weak-50",
        _hover: { bg: "neutrals.background.soft-200" },
        _active: { bg: "neutrals.background.sub-300" },
      };
    },
  },
  defaultProps: {
    variant: "solid",
    colorScheme: "brand",
  },
});

export default Button;
